/// <reference path="../../../../typings/index.d.ts" />
/// <reference path='walkinManagerSettings.module.ts' />

module Meevo.Plugins.WalkinManagerSettings {
    export interface IDataServiceSettings extends Meevo.Components.CommonClasses.ICommonDataService {
        getItem<T, TSearch>(baseEndpoint: string, id?: Guid, sectionEndpoint?: string): angular.IPromise<T[]>
    }

    export class WalkInDataServiceSettings extends Meevo.Components.Common.BusinessInfoDataService implements IDataServiceSettings {

        constructor(
            protected appSettings: Meevo.Components.Common.IAppSettings,
            protected $http: angular.IHttpService,
            protected $q: angular.IQService,
        ) {
            super(appSettings, $http, $q);
        }

        /**
         * Retrieves item data by id
         * @param {string} baseEndpoint - base end point
         * @param {Guid} [id] - item id
         * @param {string} [sectionEndpoint] - section end point
         * @return {IPromise<T>}
         */
        getItem<T, TSearch>(baseEndpoint: string, id?: Guid, sectionEndpoint?: string): angular.IPromise<T[]> {
            let uri = '';

            if (id && sectionEndpoint) {
                uri = `/${this.appSettings.API_ROOT}/${baseEndpoint}/${id}/${sectionEndpoint}`;
            } else if (id) {
                uri = `/${this.appSettings.API_ROOT}/${baseEndpoint}/${id}`;
            } else {
                uri = `/${this.appSettings.API_ROOT}/${baseEndpoint}`;
            }

            return this.$http.get<T[]>(uri)
                .then((response) => response.data);
        }

        static factory(): Function {
            let svc = (
                appSettings: Meevo.Components.Common.IAppSettings,
                $http: angular.IHttpService,
                $q: angular.IQService,
            ) => {
                return new WalkInDataServiceSettings(appSettings, $http, $q);
            };

            svc.$inject = ['meevo.AppSettings', '$http', "$q"];
            return svc;
        }
    }

    angular.module('meevo.plugins.walkinManagerSettings')
        .factory('meevo.plugins.walkinManagerSettings.walkInDataServiceSettings', WalkInDataServiceSettings.factory());
}